import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { DayQuantityText } from "./dayQuantity-types";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { SliderSettings } from "../../../../Shared/components/CardLayout/SliderSettings";
const gridButtonStyles = { height: "100%", width: "100%" };
const handleDispatchDayQuantity = (dispatch) => (event) => {
    dispatch({ type: ActionTypes.SET_DAY_QUANTITY, payload: event.currentTarget.value });
    dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
};
export const useDayQuantity = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    // The currently selected quantity.
    // Use non-null assertion operator because this value will be defined if a dayQuantity module is on the flow.
    const storeCartDayQuantity = store.cart.dayQuantity;
    // Whether or not the flow is in a draft state: determines if mod config error text is shown.
    const isDraft = store.model.Flow.isDraft;
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((mod) => mod.ModuleName === ModuleNames.DAY_QUANTITY &&
        mod.Sequence === sequenceNumber &&
        mod.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const { Visible, DayQuantityOptions, PinToTop, CenterCards, IsGridLayout, ScreenLG, ScreenMD, ScreenSM, ScreenXS, GridSpacing, } = moduleConfig;
    return {
        Visible,
        DayQuantityOptions,
        PinToTop,
        CenterCards,
        IsGridLayout,
        ScreenLG,
        ScreenMD,
        ScreenSM,
        ScreenXS,
        GridSpacing,
        sliderSettings: SliderSettings(ScreenLG, ScreenMD, ScreenSM, ScreenXS),
        storeCartDayQuantity,
        isDraft,
        invalidConfigurationText: DayQuantityText.InvalidConfiguration,
        gridButtonStyles,
        handleDispatchDayQuantity: handleDispatchDayQuantity(dispatch),
    };
};
